<template>
    <PasswordReset></PasswordReset>
</template>

<script>
    import PasswordReset from "../components/PasswordReset";

    export default {
        name: "password-reset",
        components: {
            PasswordReset
        }
    };
</script>